export const IconDiamond = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}
    >
      <mask
        id="IconDiamond_svg__a"
        width={24}
        height={24}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "alpha",
        }}
      >
        <path d="M0 0h24v24H0z" />
      </mask>
      <g mask="url(#IconDiamond_svg__a)">
        <path d="M12 19.875q-.424 0-.825-.187a2.1 2.1 0 0 1-.7-.538L2.825 10a2 2 0 0 1-.338-.6 2 2 0 0 1-.112-.675q0-.225.038-.463.038-.237.162-.437L4.45 4.1q.276-.5.737-.8Q5.65 3 6.226 3h11.55q.575 0 1.038.3.462.3.737.8l1.875 3.725q.125.2.162.437.038.238.038.463 0 .35-.113.675a2 2 0 0 1-.337.6l-7.65 9.15q-.3.35-.7.538a1.9 1.9 0 0 1-.825.187M9.625 8h4.75l-1.5-3h-1.75zM11 16.675V10H5.45zm2 0L18.55 10H13zM16.6 8h2.65l-1.5-3H15.1zM4.75 8H7.4l1.5-3H6.25z" />
      </g>
    </svg>
  );
};
